(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('DateUtil', DateUtilService);

    DateUtilService.$inject = ['$resource', '$moment'];

    function DateUtilService($resource, $moment) {

        return {
            fromString: fromString,
            jalaliToGregorian: jalaliToGregorian,

        };

        function fromString(datestr) {

            var date = $moment(datestr, "YYYY-MM-DD[T]HH:mm:ss");

            return date;
        }
        function jalaliToGregorian(input) {
            var g_days_in_month = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            var j_days_in_month = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];

            var dateSplitted = input.split("/");
            var j_y = parseInt(dateSplitted[0], 10);
            var j_m = parseInt(dateSplitted[1], 10);
            var j_d = parseInt(dateSplitted[2], 10);

            var jy = j_y - 979;
            var jm = j_m - 1;
            var jd = j_d - 1;

            var j_day_no = 365 * jy + Math.floor(jy / 33) * 8 + Math.floor((jy % 33 + 3) / 4);
            for (var i = 0; i < jm; ++i) j_day_no += j_days_in_month[i];
            j_day_no += jd;

            var g_day_no = j_day_no + 79;

            var gy = 1600 + 400 * Math.floor(g_day_no / 146097);
            g_day_no = g_day_no % 146097;

            var leap = true;
            if (g_day_no >= 36525) {
                g_day_no--;
                gy += 100 * Math.floor(g_day_no / 36524);
                g_day_no = g_day_no % 36524;

                if (g_day_no >= 365) g_day_no++;
                else leap = false;
            }

            gy += 4 * Math.floor(g_day_no / 1461);
            g_day_no %= 1461;

            if (g_day_no >= 366) {
                leap = false;
                g_day_no--;
                gy += Math.floor(g_day_no / 365);
                g_day_no = g_day_no % 365;
            }

            for (var i = 0; g_day_no >= g_days_in_month[i] + ((i == 1 && leap) ? 1 : 0); i++) {
                g_day_no -= g_days_in_month[i] + ((i == 1 && leap) ? 1 : 0);
            }
            var gm = i + 1;
            var gd = g_day_no + 1;
            return new Date(gy, gm - 1, gd);       
        }

    }
})();
